import { Component, Input, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/admin.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-prepaid-management',
  templateUrl: './prepaid-management.component.html',
  styleUrls: ['./prepaid-management.component.scss']
})
export class PrepaidManagementComponent implements OnInit {
  @Input() userId;
  @Input() amount;
  public prepaidModel = {
    amount: 0
  };

  constructor(private userService: UserService,private adminService: AdminService, private alertSevice: HttpAlertService) { }

  ngOnInit(): void {
     this.adminService.getUserWithDetails(this.userId).subscribe({
       next: response => {
         this.prepaidModel.amount = response.data.user.user_details.prepaid_amount / 100
       }
     })
  }

  public save() {
    const amount = this.prepaidModel.amount * 100;
      this.userService.updatePrepaidAmount({userId: this.userId, amount: amount}).subscribe({
        complete: () => {
          this.alertSevice.success('Zmieniono kwote doładowania');
        }
      });
  }

}
